import ResourceManager from "@/pages/admin/components/ResourceManager";
import type { ColumnConfig, FieldConfig } from "@/lib/adminFields";

const fields: FieldConfig[] = [
  { name: "titulo", label: "Título del servicio", type: "text", required: true },
  { name: "slug", label: "Identificador (slug)", type: "text", placeholder: "Ej. mudanzas", help: "Solo para uso interno" },
  { name: "icono", label: "Icono (Remix)", type: "text", placeholder: "ri-truck-line", help: "Nombre del icono, ej. ri-home-4-line" },
  { name: "destacado", label: "Destacado en el inicio", type: "switch" },
  { name: "orden", label: "Orden", type: "number", help: "Número menor aparece primero" },
  { name: "activo", label: "Visible en el sitio", type: "switch" },
  { name: "descripcion", label: "Descripción", type: "textarea", full: true },
  { name: "imagen_url", label: "Imagen", type: "image", full: true, folder: "servicios" },
];

const columns: ColumnConfig[] = [
  { name: "imagen_url", label: "Imagen", type: "image" },
  { name: "titulo", label: "Servicio" },
  { name: "slug", label: "Slug", type: "muted" },
  { name: "orden", label: "Orden", type: "muted" },
  { name: "activo", label: "Visibilidad", type: "switch" },
];

export default function AdminServicios() {
  return (
    <ResourceManager
      table="servicios"
      title="Gestión de servicios"
      description="Edita los servicios que ofrece la empresa: nombre, descripción, icono, imagen y orden de aparición."
      itemSingular="servicio"
      itemPlural="servicios"
      emptyIcon="ri-service-line"
      titleField="titulo"
      subtitleField="slug"
      imageField="imagen_url"
      searchPlaceholder="Buscar por título…"
      fields={fields}
      columns={columns}
    />
  );
}